// extracted by mini-css-extract-plugin
export default {"App":"AccountOwner_App__NVbBp","containerAccountOwner":"AccountOwner_containerAccountOwner__rAtdt"};